// trade-in-api.js
const API_URL = 'https://erp.usedphotopro.com/data/External/Models';
const appServiceUrl = "https://panasonic-trade-in-discount-code-generator-bsb2azcedebyh4db.eastus-01.azurewebsites.net"
// const appServiceUrl = "https://93578b9ca72f.ngrok-free.app"

// hit this endpoint early to warm up the server in case Azure has spun it down due to inactivity
function warmupIfStale() {
  const KEY = 'panasonicTradeIn.warmupLastAt';
  const INTERVAL = 10 * 60 * 1000; // 10 minutes
  try {
    const now = Date.now();
    const last = parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
    if (!last || now - last >= INTERVAL) {
      // Fire-and-forget; keepalive so it won't be canceled on navigation
      fetch(`${appServiceUrl}/_warmup`, { method: 'GET', keepalive: true }).catch(() => {});
      localStorage.setItem(KEY, String(now));
    }
  } catch (e) {
    // Fallback if localStorage is unavailable; send once per page session
    if (!window.__tradeInWarmupSent) {
      fetch(`${appServiceUrl}/_warmup`, { method: 'GET', keepalive: true }).catch(() => {});
      window.__tradeInWarmupSent = true;
    }
  }
}
warmupIfStale()
const DISCOUNT_API = `${appServiceUrl}/getCode`;
const TRADE_IN_URL = 'https://robertscamera.com/send/panasonic-lumix.php';

// Accept optional options: { signal, limit }
async function fetchModels(query = null, options = {}) {
  const { signal, limit } = options || {};
  const q = typeof query === "string" ? query.trim() : query;

  const init = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    signal
  };

  const payload = {};
  if (q) payload.query = q;
  if (typeof limit === "number") payload.limit = limit;
  if (Object.keys(payload).length) init.body = JSON.stringify(payload);

  const res = await fetch(API_URL, init);
  if (!res.ok) {
    throw new Error(`Failed to fetch models: ${res.status} ${res.statusText}`);
  }

  const data = await res.json();
  // Normalize: return { success, models }
  const success = !!data?.success;
  const models = Array.isArray(data?.results) ? data.results : [];
  return { success, models };
}


async function getToken() {
  const data = await fetch(`${appServiceUrl}/getToken`).then(res => res.json())
  if(data.error) {
    console.log("Could not get token: ", data.error)
    return null
  }
  return data.token
}

async function submitTradeIn(payload) {
  console.log("Submitting trade-in with payload: ", payload);
  try {
    const response = await fetch(TRADE_IN_URL, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(payload) 
    })
    if(!response.ok) {
      throw new Error(`Failed to submit trade-in: ${response.status} ${response.statusText}`);
    }
    return { success: true }
  } catch (error) {
    console.error("Error submitting trade-in: ", error);
    return { error }
  }
}

async function getDiscountCode(args) {
  const { productId, variantId, storeUrl } = args
  try {
    const token = await getToken()

    if(!token) 
      throw new Error('Failed to retrieve authentication token');
    
    const res = await fetch(`${appServiceUrl}/getCode`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "x-trade-in-token": token
      },
      body: JSON.stringify({ productId, variantId, storeUrl })
    });

    if (!res.ok) 
      throw new Error(`Failed to get discount code: ${res.status} ${res.statusText}`)

    const data = await res.json();
    
    if (!data.ok || !data.discount) 
      throw new Error('Invalid discount response')
    
    console.log("Discount code received: ", data.discount)
    return data.discount;
  } catch (error) {
    console.error("Error getting discount code: ", error);
    return null
  }
}

async function addToCart(productId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: productId,
        quantity
      })
    })
    if(!res.ok) {
      console.log("Error adding " + productId + " to cart: ", res.status, res.statusText)
      throw new Error(`Failed to add product to cart: ${res.status} ${res.statusText}`);
    }
    const data = await res.json()
    return data
  } catch (error) {
    console.error(error);
  }
}
